import { render, staticRenderFns } from "./SubscribeBasicInformation.vue?vue&type=template&id=5f05fc84&scoped=true"
import script from "./SubscribeBasicInformation.vue?vue&type=script&lang=js"
export * from "./SubscribeBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBasicInformation.vue?vue&type=style&index=0&id=5f05fc84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05fc84",
  null
  
)

export default component.exports